import { render, staticRenderFns } from "./TreeMenu.vue?vue&type=template&id=3e55a065&scoped=true"
import script from "./TreeMenu.vue?vue&type=script&lang=js"
export * from "./TreeMenu.vue?vue&type=script&lang=js"
import style0 from "./TreeMenu.vue?vue&type=style&index=0&id=3e55a065&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e55a065",
  null
  
)

export default component.exports